<template>
  <section class="form-questions">
    <div class="base-container-first form-questions__container">
      <BaseForm
        class="form-questions__wrapper"
        @submit="(event) => handleSubmit(event)"
      >
        <div class="questions__header">
          <h2
            class="questions-header__title typography__headline2"
            v-html="title"
          />

          <p
            class="questions-header__description typography__body1"
            v-html="description"
          />
        </div>

        <div class="questions__container">
          <div class="questions__wrapper">
            <BaseInput2
              v-model="fields.name[0].value"
              v-bind="fields.name[1].value"
              class="base-input-first"
              :error="errors.name"
              name="name"
              :placeholder="t('entities.contactForm.name.placeholder')"
            />

            <BaseInput2
              v-model="fields.nickname[0].value"
              v-bind="fields.nickname[1].value"
              class="base-input-first"
              :error="errors.nickname"
              name="nickname"
              :placeholder="t('pages.client.contacts.inputs.nickname.placeholder')"
              type="nickname"
            />

            <BasePhoneInput
              v-model="fields.phone[0].value"
              class="base-input-first"
              :error="errors.phone"
              name="phone"
              :placeholder="t('entities.contactForm.phone.placeholder')"
            />

            <BaseTextarea2
              v-model="fields.question[0].value"
              v-bind="fields.question[1].value"
              class="base-textarea-first"
              :error="errors.question"
              name="question"
              :placeholder="t('entities.contactForm.question.placeholder')"
            />
          </div>

          <BaseButton2
            class="base-button-big base-button-second questions__button"
            class-loader="base-loader-first"
            :loading
            type="submit"
          >
            {{ t("entities.contactForm.submit") }}
          </BaseButton2>
        </div>
      </BaseForm>
    </div>
  </section>
</template>

<script setup lang="ts">
interface Props {
  description: string;
  title: string;
}

defineProps<Props>();

const { t } = useI18n();
const { errors, fields, handleSubmit, loading } = useMakeContactOrderForm();
</script>

<style scoped>
.form-questions {
  background-color: var(--grey-7);
}

.form-questions__container {
  margin: 0 auto;
  padding-top: 80px;
  padding-bottom: 80px;
}

@media (--desktop) {
  .form-questions__container {
    padding-top: 120px;
    padding-bottom: 120px;
  }
}

.form-questions__wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 40px;
  width: 100%;
}

@media (--desktop) {
  .form-questions__wrapper {
    flex-direction: row;
    column-gap: 40px;
  }
}

.questions__header {
  display: flex;
  flex-direction: column;
  row-gap: 12px;
}

@media (--desktop) {
  .questions__header {
    row-gap: 16px;
  }
}

@media (--desktop) {
  .questions-header__title {
    font-size: 60px;
    line-height: 1.1;
  }
}

@media (--desktop) {
  .questions-header__description {
    font-size: 18px;
  }
}

.questions__container {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  width: 100%;
}

@media (--desktop) {
  .questions__container {
    max-width: 388px;
  }
}

.questions__wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 12px;
}

.questions__button {
  align-self: center;
  width: 100%;
  padding-top: 12px;
  padding-bottom: 12px;
  border-radius: 30px;
}

@media (--desktop) {
  .questions__button {
    padding-top: 16px;
    padding-bottom: 16px;
  }
}
</style>
